var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "address-verifier" } }, [
    _c(
      "div",
      { staticClass: "has-text-centered", attrs: { id: "address-header" } },
      [
        _c("BaseIcon", {
          attrs: {
            isCustom: true,
            icon: _vm.ICON_NAMES.SERVICE_TYPE.DELIVERY,
            size: _vm.$mq === "mobile" ? "3x" : "4x",
            classNames: ["order-icon", "store-navigation-color"]
          }
        }),
        _vm._v(" "),
        _vm._m(0)
      ],
      1
    ),
    _vm._v(" "),
    _vm.editLocation
      ? _c(
          "div",
          [
            _vm.getGmapAPIKey
              ? _c("GmapAutocomplete", {
                  staticClass:
                    "input is-medium is-hovered auto-complete-field text-input",
                  attrs: { placeholder: "Address", type: "text" },
                  on: { place_changed: _vm.verifyAddress }
                })
              : _vm._e(),
            _vm._v(" "),
            !_vm.getGmapAPIKey
              ? _c("input", {
                  staticClass:
                    "input is-medium is-hovered auto-complete-field text-input",
                  attrs: {
                    id: "address-field",
                    type: "text",
                    placeholder: "Enter Address"
                  },
                  on: { blur: _vm.addAddressFromField }
                })
              : _vm._e(),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "control", attrs: { id: "address-details" } },
              [
                _c("div", { staticClass: "columns is-mobile is-gapless" }, [
                  _c("div", { staticClass: "column is-narrow" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.aptNum,
                          expression: "aptNum"
                        }
                      ],
                      staticClass: "input text-input",
                      attrs: { type: "text", placeholder: "Apt #" },
                      domProps: { value: _vm.aptNum },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.aptNum = $event.target.value
                        }
                      }
                    })
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "column" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.note,
                          expression: "note"
                        }
                      ],
                      staticClass: "input text-input",
                      attrs: {
                        type: "text",
                        placeholder: "Notes, Instructions, etc."
                      },
                      domProps: { value: _vm.note },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.note = $event.target.value
                        }
                      }
                    })
                  ])
                ])
              ]
            ),
            _vm._v(" "),
            _c("BaseButton", {
              attrs: { title: "Submit", classNames: ["button--modifier"] },
              nativeOn: {
                click: function($event) {
                  return _vm.saveProposedAddress($event)
                }
              }
            })
          ],
          1
        )
      : _vm._e(),
    _vm._v(" "),
    _c(
      "h5",
      {
        staticClass: "is-size-5",
        class: {
          "store-navigation-color": _vm.msg.type === "err",
          "success-color": _vm.msg.type === "success"
        }
      },
      [_vm._v(_vm._s(_vm.msg.txt))]
    ),
    _vm._v(" "),
    _vm.msg.txt ? _c("hr") : _vm._e(),
    _vm._v(" "),
    _vm.nearByLocations.length
      ? _c(
          "div",
          [
            _c("h5", { staticClass: "is-size-5" }, [
              _c("b", [
                _vm._v(
                  _vm._s(
                    _vm.franchisor.paymentLoyaltyFlowModel.localMarketingName
                  ) + " Locations"
                )
              ])
            ]),
            _vm._v(" "),
            _vm._l(_vm.nearByLocations, function(location, key) {
              return _c("location-card", {
                key: key,
                attrs: {
                  name: location.name,
                  address: location.address,
                  phone: location.contact_phone,
                  locationBase: location.id,
                  location: location,
                  showDetails: location.id === _vm.focusedLocationId
                },
                on: {
                  emitActive: function($event) {
                    _vm.focusedLocationId = location.id
                  },
                  emitHide: function($event) {
                    _vm.focusedLocationId = null
                  },
                  setLocation: function($event) {
                    return _vm.setOrderLocation(location)
                  }
                }
              })
            })
          ],
          2
        )
      : _vm._e()
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("h3", { staticClass: "is-size-3" }, [
      _c("b", [_vm._v("Choose your delivery address")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-345223d6", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-345223d6","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/orders/initial-order-setup/AddressVerifier.vue
// module id = null
// module chunks = 